import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const StyledButtons = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-self: self-end;
`

export const SkeletonInput = () => {
  return (
    <div>
      <Skeleton width='50%' />
      <Skeleton height={32} />
    </div>
  )
}

export const SkeletonButtons = () => {
  return (
    <StyledButtons>
      <Skeleton width={100} height={32} />
      <Skeleton width={100} height={32} />
    </StyledButtons>
  )
}

export const SkeletonForm = () => {
  return (
    <StyledWrapper>
      {Array.from({length: 5}).map((_, index) => (
        <SkeletonInput key={index} />
      ))}

      <SkeletonButtons />
    </StyledWrapper>
  )
}
